<template>
  <div style="background-color: white">

      <van-nav-bar title="数据统计" />
      <!-- 搜索栏 -->
      <div>

      </div>
      <div class="my_field_search">
        <van-field v-model="fieldValue" is-link readonly :placeholder="search_title" @click="cascader_show = true" />
        <van-popup v-model="cascader_show" closeable round position="bottom">
          <div style="height: 50px;display: flex;justify-content: center;align-items: flex-end;font-size: 20px;font-weight: bold;" class="title">
            全部筛选
          </div>
          <div style="background-color: #fcfdfe;width: 100%;padding: 15px;">
            <div style="width: 100%;font-size: 16px">
              已筛选
            </div>
            <div>
              <div style="display: flex;margin-top: 5px;">
                <div class="popup-one" style="margin-right: 10px;">设备名称：{{deviceName}}</div>
                <div class="popup-one" style="margin-right: 10px;">告警类型：{{algName}}</div>
              </div>
              <div style="display: flex;margin-top: 10px;">
                <div class="popup-one" style="margin-right: 10px;">开始时间：{{startTime}}</div>
                <div class="popup-one" style="margin-right: 10px;">结束时间：{{endTime}}</div>
              </div>
            </div>
          </div>
          <div style="display: flex;background-color: #ffffff;width: 100%;">
            <div style="display: flex;flex-direction: column;width: 25%;height: 100%;">
              <div class="popup-item" v-for="(item, index) in leftArray" :class="{ active: index == leftIndex }" @click="changeLeftIndex(index)">{{item}}</div>
            </div>
            <div style="width: 75%;padding: 20px;height: 300px">
              <div v-show="leftIndex === 0" >
                <van-picker   :columns="deviceList" @change="onChange0" @cancel="onCancel0" @confirm="onConfirm0"  show-toolbar/>
              </div>
              <div v-show="leftIndex === 1" style="width: 100%;height: 100%;">
                <van-datetime-picker
                  style="height: 100%"
                  v-model="currentDate1"
                  type="date"
                  :formatter="formatter"
                  @confirm="confirm1"
                  @cancel = "cancel1"
                />

              </div>
              <div v-show="leftIndex === 2" style="width: 100%;height: 100%;">
                <van-datetime-picker
                  style="height: 100%"
                  v-model="currentDate2"
                  type="date"
                  :formatter="formatter"
                  @confirm="confirm2"
                  @cancel = "cancel2"
                />
              </div>
              <div v-show="leftIndex === 3" style="width: 100%;height: 100%;">

                <van-picker :columns="algTypeList" @change="onChange3"  @cancel="onCancel3" @confirm="onConfirm3"  show-toolbar/>
              </div>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 15px;margin-bottom: 15px">
            <van-button style="width: 150px;" type="primary" plain @click="reset">
              重置
            </van-button>
            <van-button style="width: 150px;"  type="primary" @click="sure">
              确定
            </van-button>
          </div>
        </van-popup>


      </div>
    <div v-if="dataList.length >0">
      <div  v-for="(item,index) in dataList" :key="index"  @click="alertFn(item)">
        <van-text-box
          :cover="item.alarmPic ? item.alarmPic : 'http://192.168.30.111:9000/alarmpic/dff9e994-70b2-4e6f-8faf-0f290ecdf61a'"
          type="2"
          :title="item.deviceName"
          :content="item.algName"
          :sub-content="item.alarmTime"
        >
          <div slot="tip" class="van-color-text-secondary flex-align">
            <img src="../../assets/images/field/field_mouse.png">
          </div>
        </van-text-box>
      </div>
    </div>
    <div v-else>
      <img src="../../assets/images/field/no-data.png" alt="" style="width: 80%;height: 80%;margin-top: 40%;margin-left: 10%">
    </div>

  </div>
</template>

<script>
import {
  getSearchQuery,
  getDeviceList,
  getAlgConfigList
} from '@/api'
import { dateFormat } from '@/utils'
export default {
  data() {
    return {
      showAction: false,
      currentDate1: new Date(),
      currentDate2: new Date(),
      startTime: '',
      endTime: '',
      algName: '',
      deviceName: null,
      leftIndex: 0,
      leftArray: [ "设备","开始时间", "结束时间","告警类型"],
      algTypeList: [],
      algList: [],
      deviceList: [],
      queryForm:{
        deviceName: '',
        startTime: '',
        endTime: '',
        algCode: '',
        status: '',
        pages: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        roleCode: localStorage.getItem('roleCode')
      },
      dataList:[],
      user: { dept: {} }, // 当前用户对象
      search_title: '请选择告警类型 > 日期 > 设备',
      cascader_show: false, // 控制级联选择框显示与隐藏
      submit_show: false, //  控制预定确认框显示与隐藏
      orderInfo_show: false, // 控制电子预订单的显示与隐藏
      fieldValue: '',
      cascaderValue: '',
      fieldList: this.$globalVariable.fieldList, // 静态场地列表
      venueId: -1,
      venueName: '',
      selectedOptions: [],
      alert_show: false // 弹窗显示与隐藏
    }
  },
  async created() {
    this.getDataList()
    this.getAlgConfigList()
    this.getDeviceList()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    window.addEventListener('popstate', () => {
      this.goBack();
    })
  },
  methods: {

    goBack() {
      this.$router.push({ path: 'home' })
    },
    handleScroll(){
      const _this = this
      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;

      // 检查是否滚动到了页面底部
      if (scrollHeight - scrollTop - clientHeight < 200) {
        // 200 是一个滚动到底部前的偏移量
        console.log('-----------_this.queryForm.pages:',_this.queryForm.pages)
        console.log('-----------_this.queryForm.pageNo:',_this.queryForm.pageNo)
        if (_this.queryForm.pages > _this.queryForm.pageNo) {
          _this.queryForm.pageNo += 1;
          _this.getDataListBottom();
        } else {
          // _this.$toast({
          //   message: "这是全部的内容",
          // });
        }
        // 执行的代码......
      }
    },
    getDeviceList(){
      this.deviceList = []
      getDeviceList().then(res=>{
        res.data.data.forEach(item=>{
          this.deviceList.push(item.deviceName)

        })
      })
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      }
      return value;
    },
    onChange0(picker, value, index) {
      this.deviceName = value
    },
    onConfirm0(value, index) {
      this.deviceName = value
    },
    onCancel0(value, index) {
      this.deviceName = ''
    },
    confirm1(value){
      this.startTime = dateFormat('YYYY-mm-dd',value)
    },
    confirm2(value){
      this.endTime = dateFormat('YYYY-mm-dd',value)
    },
    cancel1(){
      this.startTime = ''
    },
    cancel2(){
      this.endTime = ''
    },
    onChange3(picker, value, index) {
      this.algName = value
    },
    onCancel3(value, index){
      this.algName = ''
    },
    onConfirm3(value, index){
      this.algName = value
    },
    getAlgConfigList(){
      this.algTypeList = []
      getAlgConfigList().then(res=>{
        this.algList = res.data.data
        res.data.data.forEach((item)=>{
          this.algTypeList.push(item.algName)

        })
      })
    },
    onSearch() {
      this.queryForm.pageNo = 1
      this.getDataList()
    },
    onCancel() {
      this.queryForm.deviceName = ''
      this.queryForm.pageNo = 1
      this.getDataList()
    },
    reset(){
      this.startTime = ''
      this.endTime = ''
      this.algName = ''
      this.deviceName = ''
    },
    sure(){
      this.queryForm.pageNo = 1
      if(this.startTime === '' && this.endTime !== ''){
        this.$toast('请选择开始时间')
        return
      }
      if(this.startTime !== '' && this.endTime === ''){
        this.$toast('请选择结束时间')
        return
      }
      if(this.startTime> this.endTime){
        this.$toast('开始时间不能大于结束时间')
        return
      }

      this.queryForm.startTime = this.startTime
      this.queryForm.endTime= this.endTime
      const item1 = this.algList.filter(obj => obj.algName === this.algName)
      console.log('------item1:',item1)
      if(item1.length !== 0){
        this.queryForm.algCode= item1[0].algCode
      }

      this.queryForm.deviceName= this.deviceName
      this.getDataList()
      this.cascader_show = false
    },
    changeLeftIndex(index){
      this.leftIndex = index
    },
    getDataListBottom() {
      getSearchQuery(this.queryForm).then((res) => {
        if(res.data.state === 200){
          this.dataList = this.dataList.concat(res.data.data.records)

          this.queryForm.total = res.data.data.total
          this.queryForm.pages = res.data.data.pages
        }
      })
    },
    getDataList() {
      getSearchQuery(this.queryForm).then((res) => {
        if(res.data.state === 200){
          this.dataList = res.data.data.records
          this.queryForm.total = res.data.data.total
          this.queryForm.pages = res.data.data.pages
        }
      })
    },
    alertFn(data) {
      this.$router.push({ path: 'field/indexdetail',query:{data:data}  })
    }
  }
}
</script>
<style lang="less" scoped>
.popup-one{
  font-size: 12px;
  padding: 5px 8px;
  background: #F6F7FB;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #EAECF3;
}
.popup-item{
  width:100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f6f7fb;
  font-size: 12px;
  color: #777A89;
  &.active {
    color: #165DFF;
    background-color: #fff;
  }
}

.buttons{
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 3 columns by default */
  gap: 10px; /* Space between buttons */
  width: fit-content;
}
.button1{
  border-radius: 4px;
  width:65px;
  height: 40px;
  margin-bottom: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f7fb;
  color: black;
  font-size: 12px;
  &.active{
    border-radius: 8px;
    background-color: #ecf2ff;
    border: 1px solid #a9c3fd;
    color: #2664fc;
  }
}
.bottom-left {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  justify-content: center;

  .bottom-left-zhan {
    width: 10px;
    height: 50px;
    background: #7ca1fe;
  }

  .bottom-left-time {
    width: 30%;
    height: 20%;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
  }

}
.my_field_search {
  width: 100%;
  display: flex;
  align-items: center;
}
/deep/ .van-text-box{
  margin: 10px;
}
/deep/ .van-text-box__cover{
  height: 85px;
  width: 143px;
  border-radius: 4px 4px 4px 4px;
}
/deep/ .van-text-box__content-wrapper{
  margin-left: 20px;
}
/deep/ .van-text-box__title{
  width: 100px;
  height: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/deep/ .van-text-box__content{
  width: 100px;
  height: 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FF0303;
  line-height: 14px;
  margin-top: 3px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/deep/ .van-text-box__sub-content{
  width: 150px;
  height: 17px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  margin-top: 11px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/deep/ .van-picker__columns{
  height: 250px !important;
}
</style>
